import { cn } from '@/lib/utils'

export function LogoMark({ className }: { className?: string }) {
  return (
    <svg viewBox="0 0 32 32" aria-hidden className={cn('size-8 shrink-0', className)}>
      <rect width="32" height="32" rx="8" className="fill-[#14213d] dark:fill-[#e8ecf5]" />
      <path
        d="M11 24V8h6.5a5 5 0 0 1 0 10H11"
        fill="none"
        strokeWidth="3"
        strokeLinecap="round"
        strokeLinejoin="round"
        className="stroke-white dark:stroke-[#0b1220]"
      />
      <circle cx="23" cy="23" r="3" className="fill-brand" />
    </svg>
  )
}

export function Logo({ className }: { className?: string }) {
  return (
    <span className={cn('inline-flex items-center gap-2.5', className)}>
      <LogoMark />
      <span className="leading-none">
        <span className="block text-lg font-semibold tracking-tight">Provyn</span>
        <span className="text-muted-foreground block text-[10px] font-medium tracking-[0.18em] uppercase">
          by ZVIO
        </span>
      </span>
    </span>
  )
}
